var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVisaIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.95 15.758H3.89L2.347 9.692c-.073-.279-.229-.525-.458-.642A6.6 6.6 0 0 0 0 8.408v-.233h3.318c.458 0 .801.35.859.758l.801 4.376 2.059-5.134h2.002zm4.234 0H8.24l1.602-7.583h1.945zm4.119-5.482c.057-.409.4-.642.801-.642a3.53 3.53 0 0 1 1.888.35l.344-1.633A4.8 4.8 0 0 0 15.562 8C13.674 8 12.3 9.05 12.3 10.508c0 1.11.973 1.692 1.66 2.042.743.35 1.03.584.972.933 0 .525-.572.759-1.143.759a4.8 4.8 0 0 1-2.003-.467l-.343 1.633c.687.292 1.43.409 2.117.409 2.117.057 3.432-.992 3.432-2.567 0-1.983-2.69-2.1-2.69-2.974m9.497 5.482-1.545-7.583h-1.659a.86.86 0 0 0-.801.583l-2.86 7h2.002l.4-1.108h2.46l.23 1.108zm-2.917-5.54.571 2.857h-1.602z",
  clipRule: "evenodd"
})));
export default SvgVisaIcon;